{
  "messages": {
    "rescheduledOnce": "Đã đổi lịch một lần",
    "rescheduledTwice": "Đã đổi lịch hai lần",
    "rescheduledCountTimes": "Đã đổi lịch {count} lần"
  }
}
